export class Login {
    options = {
        companyLoginField: '#company-login',
        companyLoginError: '#company-login-error',
        companyLoginButton: '#company-login-button',
    };

	constructor(options) {
		const _this = this;
		_this.options = $.extend(_this.options, options);

		const loginField = $(_this.options.companyLoginField);
		const loginButton = $(_this.options.companyLoginButton);

		// Initially disable the button
		loginButton.prop('disabled', true);

		/**
		 * Allow only letters, numbers, hyphens, underscores, and spaces.
		 * Prevents unwanted symbols from being typed.
		 */
		loginField.on('keypress', function (event) {
			return /^[a-z0-9\-_ ]$/i.test(event.key);
		});

		/**
		 * Sanitize pasted or typed input by removing disallowed characters.
		 * Also trims spaces from the beginning and end of the value.
		 * Enables or disables the login button based on field content.
		 */
		loginField.on('input', function () {
			const cleanedValue = $(this)
				.val()
				.replace(/[^a-z0-9\-_ ]/ig, '')
				.trim();

			$(this).val(cleanedValue);

			// Enable button only if the field is not empty
			if (cleanedValue.length > 0) {
				loginButton.prop('disabled', false);
			} else {
				loginButton.prop('disabled', true);
			}
		});

		/**
		 * Handle the login button click.
		 * Sends a GET request to validate the company login and redirects if successful.
		 */
		loginButton.on('click', function () {
			$(_this.options.companyLoginError).html('').hide();

			const loginValue = $(loginField).val().trim();
			if (!loginValue) return; // Extra safeguard

			$.get(
				_this.options.path.loginCompanyLink + '/' + loginValue,
				function (result) {
					if (result.success) {
						location.href = result.result;
					} else {
						$(_this.options.companyLoginError)
							.html(_t(result.error))
							.show();
					}
				},
				'json'
			);
		});
	}
}
